import { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import usePermissions from "../../hooks/usePermissions";
import ToolbarButton from "../common/Toolbar-button";
import AppModal from "../common/AppModal";
import AddStaffModal from "./add-staff-modal";
import AppSnackbar from "../common/AppSnackbar";
import { useAppDispatch } from "../../app/hooks";
import { reset } from "../../features/staff/staffSlice";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";

interface IProps {
  GetAllStaffPermissions: () => void;
  setOpenErrorToast: any
  setOpenSnackbar:any
}

export const StaffListToolbar = ({ GetAllStaffPermissions, setOpenErrorToast,setOpenSnackbar }: IProps) => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  
  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          py: 2,
        }}
      >
        <ToolbarButton title="Add Staff" handleOpenModal={handleOpenModal} />
      </Box>

      <AppModal
        title="Add Staff"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="md"
      >
        <AddStaffModal
          handleClose={handleCloseModal}
          setOpenSnackbar={setOpenSnackbar}
          GetAllStaffPermissions={GetAllStaffPermissions}
          setOpenErrorToast={setOpenErrorToast}
        />
      </AppModal>
    </>
  );
};
